import { render, staticRenderFns } from "./OnBoardingThirdStep.vue?vue&type=template&id=317d23af&"
import script from "./OnBoardingThirdStep.vue?vue&type=script&lang=js&"
export * from "./OnBoardingThirdStep.vue?vue&type=script&lang=js&"
import style0 from "./OnBoardingThirdStep.vue?vue&type=style&index=0&id=317d23af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports